import { render } from "./ConfirmDashboard.vue?vue&type=template&id=d7e6d96a"
import script from "./ConfirmDashboard.vue?vue&type=script&lang=js"
export * from "./ConfirmDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__